export enum LOCAL_STORAGE_KEYS {
	EXPIRY = "expiry",
	THEME = "theme",
}
